import { mode } from "@chakra-ui/theme-tools";

/** @type {import("@chakra-ui/react").ComponentStyleConfig} */
export const TEXT_THEME = {
  baseStyle(props) {
    const { colorScheme } = props;
    return {
      color: colorScheme
        ? mode(`${colorScheme}.600`, `${colorScheme}.300`)(props)
        : mode("brandPrimary.700", "whiteAlpha.900")(props),
    };
  },
  defaultProps: {
    variant: "text-default",
  },
  variants: {
    h1: {
      fontFamily: "'Playfair Display', sans-serif",
      fontSize: { base: "1.875rem", xl: "2.5rem" },
      fontWeight: 400,
      lineHeight: "normal",
      color: "brandPrimary.900",
    },
    h2: {
      fontFamily: "'Lato', sans-serif",
      fontSize: { base: "1.5rem", xl: "2.125rem" },
      fontWeight: 300,
      lineHeight: "normal",
    },
    h3: {
      fontFamily: "'Playfair Display', sans-serif",
      fontSize: { base: "1.375rem", xl: "2rem" },
      fontWeight: 300,
      lineHeight: "normal",
    },
    h4: {
      fontFamily: "'Lato', sans-serif",
      fontSize: { base: "1.25rem", xl: "1.5rem" },
      fontWeight: 300,
      lineHeight: "normal",
    },
    "text-default": {
      fontFamily: "'Lato', sans-serif",
      fontSize: "1.125rem",
      fontWeight: 400,
      lineHeight: "1.75rem",
    },
    "text-default-black": {
      fontFamily: "'Lato', sans-serif",
      fontSize: "1.125rem",
      fontWeight: 700,
      lineHeight: "1.75rem",
    },
    "text-label": {
      fontFamily: "'Lato', sans-serif",
      fontSize: "1.125rem",
      fontWeight: 400,
      lineHeight: "1.375rem",
    },
    "text-label-carte": {
      fontFamily: "'Lato', sans-serif",
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "normal",
    },
    "text-large-black": {
      fontFamily: "'Lato', sans-serif",
      fontSize: "1.5rem",
      fontWeight: 700,
      lineHeight: "2rem",
    },
    "text-large": {
      fontSize: { base: "1.25rem", xl: "1.5rem" },
      fontWeight: 400,
      lineHeight: "2rem",
    },
    "text-small": {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: "21px",
    },
    "text-button": {
      fontSize: "1.25rem",
      fontWeight: 400,
      lineHeight: "28px",
    },
    "text-button-small": {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "normal",
    },
  },
};
